import { useState } from "react";
// import  from "@material-ui/core/MenuItem";
// import Dialog from "@material-ui/core/Dialog";
import { Stack, TextField, MenuItem, Dialog } from "@mui/material";
import LevelButtonGroup from "../Account/LevelButtonGroup";

function OpeningForm({
  okCallback,
  cancelCallback,
  visible,
  level3Codes,
  row,
}) {
  const transactionTypes = ["Debit", "Credit"];

  const [type, setType] = useState(row.transactionType);
  const [amount, setAmount] = useState(row.amount);
  const [code, setCode] = useState(row.fullcode);
  const [description, setDescription] = useState(row.Discription);

  const handleType = (event) => {
    console.log(event.target.value);
    setType(event.target.value);
  };

  const handleAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleAdd = () => {
    let codeValid = false;
    if (amount != "" && type != "") {
      codeValid = true;
    }
    if (codeValid) {
      let debitAmount = "";
      let creditAmount = "";
      if (type == "Debit") {
        debitAmount = amount;
      } else {
        creditAmount = amount;
      }
      const data = {
        debit: debitAmount,
        credit: creditAmount,
        amount,
        fullcode: code,
        Discription: description,
        transactionType: type,
      };
      okCallback(data);
    } else {
      alert("Please enter all fields");
    }
  };

  const handleCancel = () => {
    console.log(level3Codes);
    cancelCallback();
  };

  return (
    <Dialog open={visible} onClose={cancelCallback}>
      <Stack
        style={{
          minWidth: '40vw',
          height: '60vh',
          padding: '2rem',
        }}
        alignItems="center"
      >
        <TextField
          disabled
          value={code}
          style={{ width: "100%", margin: 10 }}
          id="outlined-required"
          label="Code"
          variant="standard"
        ></TextField>
        <TextField
          disabled
          value={description}
          style={{ width: "100%", margin: 10 }}
          id="outlined-required"
          label="Description"
          variant="standard"
        ></TextField>
        <TextField
          style={{ width: "100%", margin: 10 }}
          id="Tranaction-type"
          select
          label="Transaction Type"
          value={type}
          onChange={handleType}
          variant="standard"
        >
          {transactionTypes.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          value={amount}
          onChange={handleAmount}
          style={{ width: "100%", margin: 10 }}
          required
          id="outlined-required"
          label="Amount"
          type="number"
          variant="standard"
        ></TextField>

        <LevelButtonGroup handleCancel={handleCancel} handleAdd={handleAdd} />
      </Stack>
    </Dialog>
  );
}

export default OpeningForm;
